import { Link } from "react-router-dom";

const POLICIES = {
  privacy: {
    title: "Privacy Policy",
    subtitle: "Privacy Policy \u2013 Ambe Palace",
    content: [
      "Ambe Palace respects your privacy and is committed to protecting your personal data. When you visit our website, we may automatically collect information such as your browser type, IP address, time zone, and cookies to improve website performance and security.",
      "If you contact us or use certain features, we may collect personal details like your name, email, phone number, or address to respond to inquiries and provide services.",
      "Your information is stored securely and used only for necessary website operations and communication. We do not control third-party websites linked from our site.",
      "For privacy-related questions, contact us at contact@ambepalace.com."
    ]
  },
  refund: {
    title: "Returns & Refund Policy",
    subtitle: "Returns & Refund Policy \u2013 Ambe Palace",
    content: [
      "At Ambe Palace, customer satisfaction is important to us. If you wish to request a refund, cancellation, or have any concerns regarding payments or bookings, please contact us directly.",
      "To request a refund or cancellation, simply call us or contact us through the details provided on our website. Our team will review your request and assist you with the process.",
      "For refund related queries contact: contact@ambepalace.com"
    ]
  },
  terms: {
    title: "Terms & Conditions",
    subtitle: "Terms & Conditions \u2013 Ambe Palace",
    content: [
      "Welcome to Ambe Palace. By accessing our website (ambepalace.com), you agree to follow these terms and conditions. If you do not agree with any part of these terms, please do not use our website.",
      "All content on this website including text, images, and materials is the property of Ambe Palace and may not be copied, reproduced, or redistributed without permission.",
      "Our website may use cookies to improve user experience and analyze website traffic. By using the site, you agree to the use of these cookies.",
      "We are not responsible for the content of external websites linked from our site.",
      "Ambe Palace reserves the right to update or modify these terms at any time without prior notice."
    ]
  }
};

export default function PolicyPages({ page }) {
  const policy = POLICIES[page] || POLICIES.privacy;

  return (
    <div data-testid={`${page}-policy-page`}>
      <section className="bg-slate-900 py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-amber-400 mb-4 block">Legal</span>
          <h1 className="text-4xl sm:text-5xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
            {policy.title}
          </h1>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
            {policy.subtitle}
          </h2>
          <div className="space-y-5">
            {policy.content.map((para, i) => (
              <p key={i} className="text-base text-slate-600 leading-relaxed">{para}</p>
            ))}
          </div>
          <div className="mt-12 pt-8 border-t border-stone-100">
            <Link to="/" className="text-sm text-amber-600 hover:text-amber-700 font-semibold transition-colors duration-200">
              &larr; Back to Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
